import { useQuery } from "@tanstack/react-query";
import { ArchiveS3Backend } from "@graylog/enterprise-api";
import i18n from "i18n";
import UserNotification from "util/UserNotification";
export const AWS_REGIONS_QUERY_KEY = ["aws-regions"];
const fetchAWSRegions = () => ArchiveS3Backend.getAwsRegions().then((response) => response.regions).catch((error) => {
  var _a, _b, _c;
  const errorMessage = (_c = (_b = (_a = error.additional) == null ? void 0 : _a.body) == null ? void 0 : _b.message) != null ? _c : error.message;
  UserNotification.error(
    i18n.t("notifications.aws_regions_failed", { ns: "enterprise_archive", error: errorMessage }),
    i18n.t("notifications.aws_regions_failed_title", { ns: "enterprise_archive" })
  );
  throw error;
});
const useAWSRegions = () => useQuery({
  queryKey: AWS_REGIONS_QUERY_KEY,
  queryFn: fetchAWSRegions,
  retry: false
});
export default useAWSRegions;
